import { useState } from "react"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import { CredentialsStep } from "./CredentialsStep"
import { VerificationStep } from "./VerificationStep"
import { AuthTopbar } from "../../modules/AuthTopbar"
import styles from "./index.module.css"
import { Card } from "@cividao/components"

const RegisterStep = {
  CREDENTIALS: "CREDENTIALS",
  VERIFICATION: "VERIFICATION",
} as const

type RegisterStep = (typeof RegisterStep)[keyof typeof RegisterStep]

export function RegisterTemplate() {
  const { t } = useTranslation("auth")
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState<RegisterStep>(RegisterStep.CREDENTIALS)
  const [email, setEmail] = useState("")

  const handleCredentialsComplete = (userEmail: string) => {
    setEmail(userEmail)
    setCurrentStep(RegisterStep.VERIFICATION)
  }

  const handleBack = () => {
    setCurrentStep(RegisterStep.CREDENTIALS)
  }

  const isCredentials = currentStep === RegisterStep.CREDENTIALS
  const topbarText = isCredentials ? t("shared.step.credentials") : t("shared.step.verification")
  const stepNumber = isCredentials ? 1 : 2

  return (
    <main className={styles.container}>
      <AuthTopbar
        text={topbarText}
        currentStep={stepNumber}
        totalSteps={4}
        onBack={isCredentials ? () => navigate("/") : handleBack}
      />

      <div className={styles.content}>
        <Card>
          {currentStep === RegisterStep.CREDENTIALS ? (
            <CredentialsStep onComplete={handleCredentialsComplete} />
          ) : (
            <VerificationStep email={email} onBack={handleBack} />
          )}
        </Card>
      </div>
    </main>
  )
}
